import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Sidebar.scss";
import profile from "../../../../Assets/AppComponent/Profile/profile2.png";
import {
  getsidebarActions,
  getSideBarfilesActions,
  getSideBarStatus,
  setTheUDSEmployeeLogin,
  SetTHeNavigateList,
} from "../../../../Redux/Slice";
import PersonIcon from "@mui/icons-material/Person";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { NavLink } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PriceChangeIcon from "@mui/icons-material/PriceChange";





import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-32.svg";
import WhiteImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image.svg";




import DashboardWhiteIma from "../../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-34.svg";
import attendanceReport from "../../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-56.svg"
import employeementimg from "../../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-59.svg";
import attendanceregularzationImg from "../../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-48.svg";
import clientImage from "../../../../Assets/AppComponent/SideBarImages/BlackImage/UDS MEDIA ASSETS-43.svg";


import DashboardWhiteImg from "../../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-76.svg";
import attendanceReportwhite from "../../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-98.svg";
import employeementimgwhite from "../../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-101.svg";

import attendanceregularzationImgwhite from "../../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-90.svg";
import clientImagewhite from "../../../../Assets/AppComponent/SideBarImages/UDS MEDIA ASSETS-85.svg";


const SideBarUDS = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  var list2 = [];
  var list3 = [];
  var list4 = [];
  var list5 = [];

  const StatusDisplay = useSelector(
    (state) => state.sidebardispatchCall.SideStatus
  );
  const [Active, SetActive] = useState(false);
  const [check, setCheck] = useState(false);
  const stateToogle = useSelector((state) => state.SideBarActive.SidebarActive);
  const state = useSelector((state) => state);
  const [entered, setEntered] = useState(false);
  const [DropDown, setDropDown] = useState();
  const [Status, Setstatus] = useState(false);

  const UserData = useSelector((state) => state.users.UserData.data);
  const dispatch = useDispatch();
  const handleDialog = () => {
    if (stateDisplay) {
      dispatch(getsidebarActions(Active));
    }
  };

  const handleSecDailog = () => {
    if (stateDisplay) {
      dispatch(getsidebarActions(Active));
    }
  };
  const navigate = useNavigate();

  const handleClick = (link) => {
    navigate(link);
  };

  const HandleActives = (e) => {
    dispatch(getSideBarfilesActions(e));
  };

  const [Expand, setExpand] = useState();
  const [isActive, setIsActive] = useState(false);

  const [expand, setexpand] = useState();
  const sidebaractive = useDispatch();
  const RoleBased = useSelector((state) =>
    state.SideBarFiles.Role.toLowerCase()
  );

  useEffect(() => {
    let fullUrl = window.location.href;
    let url = new URL(fullUrl);
    let path = url.pathname


    if (state.NeededdatasListed.UdsLoginEMP == 1) {
      navigate("/customudsdashboard");
    }
    // if (state.SideBarFiles.SideBarFile == "Home") {
    //   navigate("/customudsdashboard");
    // }
    // if (state.SideBarFiles.SideBarFile == "ATTENDANCE") {
    //   navigate("/customattendace");

    // }
    // if (state.SideBarFiles.SideBarFile == "TEAM") {
    //   navigate("/teamemp");
    // }
    if (path == "/") {
      dispatch(setTheUDSEmployeeLogin(1));

    }
    // console.log("difusdf", window.location.hash, window.location.href, window.location.href.includes("/"),

    //   window.location.hash.includes("/"),

    //   state.SideBarFiles.SideBarFile);

    if (path != "/") {
      dispatch(setTheUDSEmployeeLogin(2));
    }

  }, [state.SideBarFiles.SideBarFile, state.NeededdatasListed.UdsLoginEMP,
  window.location.href
  ]);

  const SIDEBAR = [
    {
      id: 0,
      icon: (
        <>
          <img className="redImage" src={DashboardWhiteIma} />
          <img className="whiteImage" src={DashboardWhiteImg} />
        </>
      ),
      text: "HOME",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "HOME" ? " activesidemenu" : ""}`,
      link: "/customudsdashboard",
      // link: "/",
    },

    {
      id: 1,
      icon: (
        <>
          <img className="redImage" src={attendanceReport} />
          <img className="whiteImage" src={attendanceReportwhite} />
        </>
      ),
      text: "ATTENDANCE",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "ATTENDANCE"
          ? " activesidemenu"
          : ""
        }`,
      link: "/customattendace",
    },
    {
      id: 3,
      icon: (
        <>
          <img className="redImage" src={employeementimg} />
          <img className="whiteImage" src={employeementimgwhite} />
        </>
      ),
      text: "EMPLOYMENT",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "EMPLOYMENT"
          ? " activesidemenu"
          : ""
        }`,
      link: "/employment",
    },

    (state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.sub_role != null && state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.sub_role != 2) && {
      id: 3,
      icon: (
        <>
          <img className="redImage" src={attendanceregularzationImg} />
          <img
            className="whiteImage"
            src={attendanceregularzationImgwhite}
          />
        </>
      ),
      text: "TEAM",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "TEAM"
          ? " activesidemenu"
          : ""
        }`,
      link: "/teamemp",
    },

    {
       id: 4,
      icon: (
        <>
        <img className="redImage" src={clientImage} />
        <img className="whiteImage" src={clientImagewhite} />
      </>
      ),
      text: "SKILL ASSESSMENT",
      class:
        "adminusernav" +
        `${state.SideBarFiles.SideBarFile == "SKILL ASSESSMENT"
          ? " activesidemenu"
          : ""
        }`,
      link: "/assessments",
    },

  ];

  const expandfunc = (e, index) => {
    if (index == expand) {
      setexpand(null);
    } else if (index != expand) {
      setexpand(index);
    }
  };

  const sidebarhandleclick = (e) => {
    console.log(e, "here", state.SideBarFiles.SideBarFile);
    dispatch(getSideBarfilesActions(e));
  };

  const [Hoverd, setHovered] = useState(false);
  const hoverstate = (e, file) => {
    if (stateDisplay) {
      setHovered(true);
    }
    try {
    } catch (err) {
      console.log(err, "hover");
    }
  };

  const hoverleave = (e) => {
    if (stateDisplay) {
      setexpand(false);
      setHovered(false);

      try {
      } catch (err) {
        console.log(err, "hover");
      }
      if (list2.includes(state.SideBarFiles.SideBarFile)) {
        setexpand(9);
      } else if (list3.includes(state.SideBarFiles.SideBarFile)) {
        setexpand(5);
      } else if (list4.includes(state.SideBarFiles.SideBarFile)) {
        setexpand(13);
      } else if (list5.includes(state.SideBarFiles.SideBarFile)) {
        setexpand(15);
      }
    }
  };

  return (
    <>
      <div
        className={stateDisplay || Hoverd ? "sidebarclose" : "sidebar"}
        // className={stateDisplay  ? "sidebarclose" : "sidebar"}
        id="sidebar"
        onMouseEnter={(e) => hoverstate(e, state.SideBarFiles.SideBarFile)}
        onMouseLeave={(e) => hoverleave(e)}
      >
        <div className={` NormalSide ${Hoverd ? "handle " : "NotHovered"}`}>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar_content">
                {SIDEBAR.length > 1 &&
                  SIDEBAR != undefined &&
                  SIDEBAR != null &&
                  SIDEBAR.map((item, index) => {
                    if (item.icon) {
                      return (
                        <>
                          <NavLink
                            to={item.link}
                            style={{ textDecoration: "none" }}
                          >
                            <li
                              key={item.id}
                              className={`sideitem row  ${item.class}`}
                              href={item.link}
                              onClick={(e) => {
                                sidebarhandleclick(item.text);
                                if (item.subMenus) {
                                  expandfunc(e, index);
                                }
                              }}
                            >
                              <div href={item.link} className="col-2">
                                {item.icon}
                              </div>
                              <div
                                className={
                                  stateDisplay
                                    ? "linkText col-6"
                                    : "linkTextclosed col-6"
                                }
                                style={{
                                  display: stateDisplay ? "none" : "block",
                                  color: "#000",
                                }}
                              >
                                <NavLink
                                  //  className="nav-link"
                                  to={item.link}
                                  className={
                                    // "nav-link"
                                    ` nav-link ${item.subMenus && expand == index
                                      ? "expandeColor"
                                      : "notExpandedColor"
                                    }`
                                  }
                                >
                                  {item.text}
                                </NavLink>
                              </div>
                              {item.subMenus ? (
                                <>

                                  <div
                                    className="col-4 RightSideImage"
                                    onClick={(e) => {
                                      expandfunc(e, index);
                                    }}
                                  >
                                    <img
                                      src={BackImage}
                                      class={`CaretRightImgs BlackImgs ${expand == index
                                        ? " arrowexpand"
                                        : "arrownotexpand"
                                        } 
`}

                                    />
                                    <img
                                      src={WhiteImage}
                                      class={`CaretRightImgs  WhiteIconsImage${expand == index
                                        ? " arrowexpand"
                                        : "arrownotexpand"
                                        } 
                                `}
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </li>
                          </NavLink>
                          <ul
                            className={`sub-menu ${index}
                      
                      ${expand == index ? " activeside" : ""} 
                      
                      `}
                          >
                            {item.subMenus != undefined &&
                              item.subMenus?.map((ele) => {
                                //   console.log(ele, "segdvxc");
                                if (ele.link) {
                                  return (
                                    <NavLink
                                      to={ele.link}
                                      style={{ textDecoration: "none" }}
                                    >
                                      <li
                                        key={ele.id}
                                        className={`sideitem row ${ele.class}`}
                                        href={ele.link}
                                        onClick={(e) =>
                                          sidebarhandleclick(ele.text)
                                        }
                                      >
                                        <div href={ele.link} className="col-2">
                                          {ele.icon}
                                        </div>
                                        <span
                                          className={`SubitemWORDS  ${stateDisplay
                                            ? "linkText col-6"
                                            : "linkTextclosed col-6"
                                            }`}
                                          style={{
                                            display: stateDisplay
                                              ? "none"
                                              : "block",
                                          }}
                                        >
                                          <NavLink
                                            className="nav-link SubNavs"
                                            to={ele.link}
                                            style={{ textDecoration: "none" }}
                                          >
                                            {ele.text}
                                          </NavLink>
                                        </span>
                                      </li>
                                    </NavLink>
                                  );
                                }
                              })}
                          </ul>
                        </>
                      );
                    }
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};
export default SideBarUDS;
